import React from 'react';
import { fm } from '../../utils';
import { Users, DollarSign, Receipt } from 'lucide-react';

const LiveWidgets = ({ acikMasa = 0, canliCiro = 0, doluMasaTutar = 0 }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
    <div className="bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-2xl p-4 text-white">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-[10px] font-medium text-white/70 uppercase tracking-wider">Dolu Masa</span>
        <Users size={16} className="text-white/50" />
      </div>
      <p className="font-display font-bold text-2xl">{acikMasa}</p>
      <div className="flex items-center gap-1 mt-1">
        <div className="w-1.5 h-1.5 rounded-full bg-emerald-300 animate-pulse" />
        <span className="text-[10px] text-white/70">Canlı</span>
      </div>
    </div>
    <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl p-4 text-white">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-[10px] font-medium text-white/70 uppercase tracking-wider">Günlük Ciro</span>
        <DollarSign size={16} className="text-white/50" />
      </div>
      <p className="font-display font-bold text-2xl">{fm(canliCiro)}</p>
      <div className="flex items-center gap-1 mt-1">
        <div className="w-1.5 h-1.5 rounded-full bg-blue-300 animate-pulse" />
        <span className="text-[10px] text-white/70">Canlı</span>
      </div>
    </div>
    <div className="bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl p-4 text-white">
      <div className="flex items-center justify-between mb-1.5">
        <span className="text-[10px] font-medium text-white/70 uppercase tracking-wider">Dolu Masa Sipariş Tutarı</span>
        <Receipt size={16} className="text-white/50" />
      </div>
      <p className="font-display font-bold text-2xl">{fm(doluMasaTutar)}</p>
      <div className="flex items-center gap-1 mt-1">
        <div className="w-1.5 h-1.5 rounded-full bg-amber-300 animate-pulse" />
        <span className="text-[10px] text-white/70">Canlı</span>
      </div>
    </div>
  </div>
);

export default LiveWidgets;
